// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".logos-container {\n  margin: 20px 0 40px 0;\n  text-align: center;\n}\n.logos-container svg {\n  display: inline-block;\n}\n\n.devextreme-logo {\n  width: 200px;\n  height: 34px;\n  margin-bottom: 19px;\n}\n\n.react-logo {\n  width: 184px;\n  height: 68px;\n}\n\n.plus {\n  margin: 23px 10px;\n  width: 22px;\n  height: 22px;\n}\n\n.screen-x-small .logos-container svg {\n  width: 100%;\n  display: block;\n}\n.screen-x-small .logos-container svg.plus {\n  margin: 0;\n}", ""]);
// Exports
module.exports = exports;
